import React from "react";
import Select from "react-select";

export default function SelectField({ value, optionSData, placeholder, onChangeData }) {
    return (
        <div className="comn-input-main">
            <Select
                options={optionSData}
                onChange={onChangeData}
                value={value}
                placeholder={`Select ${placeholder}`}
                theme={(theme) => ({
                    ...theme,
                    colors: {
                        ...theme.colors,
                        primary25: "#7f176726",
                        primary50: "#7f176726",
                        primary75: "#7f176726",
                        primary: "#7f1767",
                    },
                })}
            />
        </div>
    );
}
